import { Origin } from "../../../../../models";
import { PublicVerifierDetailsPreviewTemplate } from "../../../../../templates";
import { getVerifierSettingsMarketingAssetsRoute } from "../../../../../utils/routes";
import { PreviewBanner } from "../../../../../widget";
import { usePreview } from "./usePreview";

const Preview = (): JSX.Element => {
  const { dataIsLoading, previewUuid, previewData, navigate } = usePreview();

  return (
    <>
      <PreviewBanner
        description="You are currently viewing a preview version of the page. These changes will not be published until you close the preview and save your changes"
        onClose={() => {
          navigate(
            getVerifierSettingsMarketingAssetsRoute(
              {
                origin: Origin.VerifierDetailsPreview,
              },
              previewUuid
            )
          );
        }}
      />
      {!dataIsLoading && previewData && <PublicVerifierDetailsPreviewTemplate previewData={previewData} />}
    </>
  );
};

export default Preview;
